import React from "react";
// import "../style/investmentObjective.css";
import styles from "./LearnMoreMainText.module.css";
export default function LearnMoreMainText(props) {
  return (
    <>
      <div className={styles.container}>
        <p className={styles.infoTxt}>{props.text}</p>
      </div>
    </>
  );
}
